/* 
On loading data init request setting url for each source
params tableType : type of table data materials/partners/impacts/routes
*/
export const initTableData = (tableType, url, filters = {}, id = null) => {
  return dispatch => {
    dispatch({
      type: 'INIT_TABLE_DATA_LOAD',
      tableType,
      url,
      filters,
      id
    })
  }
}


/* 
On loading data request
params tableType : type of table data materials/partners/impacts/routes
*/
export const loadTableData = (tableType) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_DATA_LOAD',
      tableType
    })
  }
}


/* 
On loading data success
params tableType : type of table data materials/partners/impacts/routes
       data    : table results
*/
export const loadTableDataSuccess = (tableType, data) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_DATA_LOAD_SUCCESS',
        tableType,
        data
      })
    }
}


/* 
On loading data fail
params tableType : type of table data materials/partners/impacts/routes
       errors    : errors
*/
export const loadTableDataFail = (tableType, errors) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_DATA_LOAD_FAIL',
        tableType,
        errors
      })
    }
}

/* 
On paging table data
params tableType : type of table data materials/partners/impacts/routes
       page    : page number
*/
export const setTableDataPage = (tableType, page) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_DATA_SET_PAGE',
        tableType,
        page
      })
    }
}


/* 
On changing table data page size
params tableType : type of table data materials/partners/impacts/routes
       page    : page size
*/
export const setTableDataPageSize = (tableType, size) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_DATA_CHANGE_PAGE_SIZE',
      tableType,
      size
    })
  }
}


/* 
On searching table data
params tableType : type of table data materials/partners/impacts/routes
       search    : search keyword
*/
export const ontTableDataSearch = (tableType, search) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_DATA_SEARCH',
        tableType,
        search
      })
    }
}


/* 
On ordering/sorting table data
params tableType  : type of table data materials/partners/impacts/routes
       sort       : sort field
       direction  : direction field
*/
export const ontTableDataSort = (tableType, sort, direction) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_DATA_SORT',
      tableType,
      sort,
      direction
    })
  }
}


/* 
On deleting table row
params tableType : type of table data materials/partners/impacts/routes
       rowId    : unique Id of the row
*/
export const ontTableRowDelete = (tableType, rowId) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_DELETE',
      tableType,
      rowId
    })
  }
}

/* 
On deleting table row request completed successfully
params tableType : type of table data materials/partners/impacts/routes
       rowId    : unique Id of the row
*/
export const ontTableRowDeleteSuccess = (tableType, rowId) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_DELETE_SUCCESS',
      tableType,
      rowId
    })
  }
}

/* 
On deleting table row request fails
params tableType : type of table data materials/partners/impacts/routes
       rowId    : unique Id of the row
       errors    : errors
*/
export const ontTableRowDeleteFail = (tableType, rowId, errors) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_DELETE_FAIL',
      tableType,
      rowId,
      errors
    })
  }
}


/* 
On adding table data
params tableType : type of table data materials/partners/impacts/routes
       data    : this is "any" type combination of string, number, File etc
*/
export const ontTableRowAdd = (tableType, data, callback) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_ADD',
      tableType,
      data,
      callback
    })
  }
}

/* 
On adding table data request completed successfully
params tableType : type of table data materials/partners/impacts/routes
       rowData    : added data
*/
export const ontTableRowAddSuccess = (tableType, rowData) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_ADD_SUCCESS',
      tableType,
      rowData
    })
  }
}


/* 
On adding table data request completed successfully but without any return data
params tableType : type of table data materials/partners/impacts/routes
       rowData    : added data
*/
export const ontTableRowAddSuccessEmpty = (tableType) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_ADD_SUCCESS_EMPTY',
      tableType
    })
  }
}

/* 
On adding table data request fails
params tableType : type of table data materials/partners/impacts/routes
       errors    : errors
*/
export const ontTableRowAddFail = (tableType, errors) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_ADD_FAIL',
      tableType,
      errors
    })
  }
}


/* 
On updating table row
params tableType : type of table data materials/partners/impacts/routes
       data    : this is "any" type combination of string, number, File etc
*/
export const ontTableRowUpdate = (tableType, id, data) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_UPDATE',
      tableType,
      id,
      data
    })
  }
}

/* 
On updating table row request completed successfully
params tableType : type of table data materials/partners/impacts/routes
       rowData    : added data
*/
export const ontTableRowUpdateSuccess = (tableType, id, rowData) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_UPDATE_SUCCESS',
      tableType,
      id,
      rowData
    })
  }
}

/* 
On updating table row request fails
params tableType : type of table data materials/partners/impacts/routes
       errors    : errors
*/
export const ontTableRowUpdateFail = (tableType, id, errors) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_ROW_UPDATE_FAIL',
      tableType,
      id,
      errors
    })
  }
}


/* 
On inititationg export request for table data
params tableType : type of table data materials/partners/impacts/routes
*/
export const onTableDataExport = (tableType, url, filters = {}) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_EXPORT',
      tableType,
      url,
      filters
    })
  }
}


/* 
On fail response of export request for table data
params tableType : type of table data materials/partners/impacts/routes
*/
export const onTableDataExportFail = (tableType) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_EXPORT_FAIL',
      tableType
    })
  }
}


/* 
On success response of export request for table data
params tableType : type of table data materials/partners/impacts/routes
*/
export const onTableDataExportSuccess = (tableType) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_EXPORT_SUCCESS',
        tableType
      })
    }
}

//import

/* 
On inititationg import request for table data
params tableType : type of table data materials/partners/impacts/routes
       data : file
*/
export const onTableDataImport = (tableType, data) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_IMPORT',
      tableType,
      data
    })
  }
}


/* 
On fail response of import request for table data
params tableType : type of table data materials/partners/impacts/routes
*/
export const onTableDataImportFail = (tableType, errors) => {
  return dispatch => {
    dispatch({
      type: 'TABLE_IMPORT_FAIL',
      tableType,
      errors
    })
  }
}


/* 
On success response of import request for table data
params tableType : type of table data materials/partners/impacts/routes
*/
export const onTableDataImportSuccess = (tableType) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_IMPORT_SUCCESS',
        tableType
      })
    }
}


//CELL_LOADING
export const onCellLoading = (tableType, id, rowIndex = 0, data) => {
  return dispatch => {
    dispatch({
      type: 'CELL_LOADING',
      tableType,
      id,
      rowIndex,
      data
    })
  }
}

export const onCellLoadingSuccess = (tableType, id, rowData) => {
  return dispatch => {
    dispatch({
      type: 'CELL_LOADING_SUCCESS',
      id,
      rowData,
      tableType
    })
  }
}

export const onCellLoadingFail = (tableType, id, errors) => {
  return dispatch => {
    dispatch({
      type: 'CELL_LOADING_FAIL',
      id,
      errors,
      tableType
    })
  }
}


/* 
  On updating registration
  params tableType : type of table data materials/partners/impacts/routes
  data    : this is "any" type combination of string, number, File etc
  */
  export const onTableRegister = (tableType, id, data) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_ROW_REGISTER',
        tableType,
        data,
        id
      })
    }
  }
  
  /* 
  On updating registration request completed successfully
  params tableType : type of table data materials/partners/impacts/routes
  rowData    : added data
  */
  export const onTableRegisterSuccess = (tableType, id) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_ROW_REGISTER_SUCCESS',
        id,
        tableType
      })
    }
  }
  /* 
  On updating registration request fails
  params tableType : type of table data materials/partners/impacts/routes
  errors    : errors
  */
  export const onTableRegisterFail = (tableType, id, errors) => {
    return dispatch => {
      dispatch({
        type: 'TABLE_ROW_REGISTER_FAIL',
        id,
        errors,
        tableType
      })
    }
  }